import { render, staticRenderFns } from "./ViewStatistics.vue?vue&type=template&id=1d6749fc&scoped=true&"
import script from "./ViewStatistics.vue?vue&type=script&lang=js&"
export * from "./ViewStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ViewStatistics.vue?vue&type=style&index=0&id=1d6749fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6749fc",
  null
  
)

export default component.exports